// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContactsOutlinedSvg from "@ant-design/icons-svg/es/asn/ContactsOutlined";
import AntdIcon from '../components/AntdIcon';

var ContactsOutlined = function ContactsOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContactsOutlinedSvg
  }));
};

ContactsOutlined.displayName = 'ContactsOutlined';
export default React.forwardRef(ContactsOutlined);